module.exports = __webpack_public_path__ + "static/Background@2x-2dbca8ae6369029c40430970fc552cbf.png";